import AbstractService from "../abstract.service";

export default class PermissionsService extends AbstractService {
  static URI_STATES = new Map([
    ["permissions", "/product_feed_permissions"],
    ["permissions_for_roi_pixel", "/product_feed_permissions_for_roi_pixel"],
    ["permissions.get", "/product_feed_permissions/{0}"],
    ["permissions.put", "/product_feed_permissions/{0}"],
    ["permissions.delete", "/product_feed_permissions/{0}"],
  ]);

  /**
   * Get all product feed permissions available.
   * @returns {Promise<*>} Returns a list of all product feed permissions available.
   */
  async getAllPermissions() {
    return await this.api_server.get(PermissionsService.URI_STATES.get("permissions"), {});
  }

  async getAllPermissionsForROIPixelPage(data) {
    return await this.api_server.get(PermissionsService.URI_STATES.get("permissions_for_roi_pixel"), data);
  }

  /**
   * Create new product feed permission.
   * @param {*} data
   * @returns
   */
  async createPermission(data) {
    return await this.api_server.post(PermissionsService.URI_STATES.get("permissions"), data);
  }

  /**
   * Get product feed permission by ID.
   * @param {*} permissionId
   * @returns
   */
  async getPermission(permissionId) {
    return await this.api_server.get(PermissionsService.URI_STATES.get("permissions.get").format(permissionId), {});
  }

  /**
   * Update existing product feed permission.
   * @param {*} permissionId
   * @param {*} data
   * @returns
   */
  async updatePermission(permissionId, data) {
    return await this.api_server.put(PermissionsService.URI_STATES.get("permissions.put").format(permissionId), data);
  }

  /**
   * Delete product feed permission by ID.
   * @param {*} permissionId
   * @returns
   */
  async deletePermission(permissionId) {
    return await this.api_server.delete(
      PermissionsService.URI_STATES.get("permissions.delete").format(permissionId),
      {},
    );
  }
}
